import { mediaMinWidth } from '@lux/core';
import styled, { css } from 'styled-components';

export const Wrapper = styled.div<{ isHidden: boolean; isSuccessPlacement: boolean }>`
    position: relative;
    top: 0;
    z-index: 10;
    margin: 20px 0 0;
    padding: 0 12px;
    width: 100%;
    transition: 300ms opacity ease-out;

    ${mediaMinWidth.sm} {
        padding: 0;
    }

    ${({ isSuccessPlacement }) =>
        isSuccessPlacement &&
        css`
            position: relative;
            top: 0;
            margin: 0 0 30px;
            width: 100%;
        `}

    ${({ isHidden }) =>
        isHidden &&
        css`
            opacity: 0;
        `}
`;
